var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bannerItems" }, [
    _vm._m(0),
    _c("div", { staticClass: "block-wrap" }, [
      _c("div", { staticClass: "item" }, [
        _c("img", {
          attrs: { src: require("../../static/images/blockChain/height.png") }
        }),
        _c("div", [
          _c("p", [_vm._v(_vm._s(_vm.blockHeight))]),
          _c("span", [_vm._v("区块链高度")])
        ])
      ]),
      _c("div", { staticClass: "item" }, [
        _c("img", {
          staticStyle: { width: "74px" },
          attrs: { src: require("../../static/images/blockChain/user.png") }
        }),
        _c("div", [
          _c("p", { domProps: { innerHTML: _vm._s(_vm.blockUser) } }),
          _c("span", [_vm._v("存证用户量")])
        ])
      ]),
      _c("div", { staticClass: "item" }, [
        _c("img", {
          staticStyle: { width: "74px" },
          attrs: { src: require("../../static/images/blockChain/data.png") }
        }),
        _c("div", [
          _c("p", { domProps: { innerHTML: _vm._s(_vm.blockData) } }),
          _c("span", [_vm._v("存证数据量")])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "b-box" }, [
      _c("img", {
        attrs: { src: require("../../static/images/blockChain/chain.png") }
      }),
      _c("div", { staticClass: "text-box" }, [
        _c("h1", [_vm._v("打破信息孤岛，全流程追踪，分布式存储，不可篡改")]),
        _c("p", [
          _vm._v(
            "保全链开放平台是由君子签联合仲裁委、版权机构、公证处、互联网法院等打造的联盟链，实现数据从生成、存储、传输到最终提交的整个环节真实可信， 司法权威节点可见，具有法律效力。"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6392d83c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6392d83c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/blockChain/banner.vue
// module id = kcBP
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37